import vibrant from 'node-vibrant';

async function extractColorSwatches(url) {
	const pallette = await vibrant.from(url).getPalette();

	let swatches = [];
	
	for (const key in pallette) {
		swatches.push({ hex: pallette[key].hex, population: pallette[key].population })
	}

	return swatches.toSorted((a, b) => b.population - a.population).slice(0, 3);
}

const colorExtractor = {
	/**
	 * After we reafactor referenceCenterUserProfile.vue to use this function
	 * rename this function colorExtractor, remove the color extractor object around it,
	 * delete updateColorsUserProfile function, and update the user profile and the company profile
	 * to just use the colorExtractor function
	 */
	async updateColorsCompanyProfile(url) {
		const swatches = await extractColorSwatches(url);

		return {
			Color1: swatches[0].hex,
			Color2: swatches[1].hex,
			Color3: swatches[2].hex
		};
	},
	// Refactor PreferenceCenterUserProfile.vue to use the function above instead of this one
	async updateColorsUserProfile(url) {
		const swatches = await extractColorSwatches(url);

		return {
			Color1: {
				name: 'Color1',
				value: swatches[0].hex,
			},
			Color2: {
				name: 'Color2',
				value: swatches[1].hex,
			},
			Color3: {
				name: 'Color3',
				value: swatches[2].hex,
			},
		};
	}
};

export default colorExtractor;